import { render, staticRenderFns } from "./SnapshotSuccessMessage.vue?vue&type=template&id=5dbf8b64"
import script from "./SnapshotSuccessMessage.vue?vue&type=script&lang=js"
export * from "./SnapshotSuccessMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports